import React from "react";
export interface ITypography {
	element: JSX.Element;
	className?: string;
}

const Typography: React.FC<ITypography> = ({ element, className = "" }) => {
	return <div className={`${className}`}>{element}</div>;
};

export default Typography;
